/**
 * Base URL for loading tag assets from CDN
 */
export const BASE_URL = 'https://static.nodals.io/lib/tag/';

/**
 * Global namespace used by Nodals products
 */
export const GLOBAL_NAMESPACE = '$nodals';

/**
 * Command queue property name (distinct from RTD's cmdQueue)
 */
export const CMD_QUEUE_PROP = 'cmd';

/**
 * Maximum age of a stored nclid click id. Beyond this the click no longer
 * attributes conversions and the activity waterfall takes over.
 */
export const NCLID_TTL_MS = 28 * 24 * 60 * 60 * 1000;

/**
 * How far in the future a stored nclid timestamp may sit before it is treated
 * as invalid (clock changes or tampering would otherwise never expire).
 */
export const NCLID_MAX_CLOCK_SKEW_MS = 24 * 60 * 60 * 1000;

/**
 * Key of the tag-owned state object, in localStorage (loader cohort state and
 * the storage manager's local backend) and as the storage manager's cookie.
 */
export const TAG_STORAGE_KEY = 'tag.nodals.ai';
